const initialAuthState = {
  currentUser: JSON.parse(localStorage.getItem("currentUser")) || null,
};

export default function authReducer(state = initialAuthState, action) {
  switch (action.type) {
    case "ON_LOGIN":
      if (!action.payload || !action.payload.email) {
        console.log("Invalid login payload.");
        return state;
      }
      return {
        ...state,
        currentUser: action.payload,
      };
    case "ON_LOGOUT":
      return {
        ...state,
        currentUser: null,
        cart: [],
      };
    default:
      return state;
  }
}

// export default function authReducer(state = initialAuthState, action) {
//   switch (action.type) {
//     case "ON_LOGIN":
//       if (!action.payload || !action.payload.email) {
//         console.log("Invalid login payload.");
//         return state;
//       }
//       const userCartKey = `cart_${action.payload.email}`;
//       const userCart = JSON.parse(localStorage.getItem(userCartKey)) || [];
//       return {
//         ...state,
//         currentUser: action.payload,
//         cart: userCart, //cập nhật giỏ hàng khi đăng nhập
//       };
//     case "ON_LOGOUT":
//       return {
//         ...state,
//         currentUser: null,
//         //cart: [], //xoá giỏ hàng khi đăng xuất
//       };
//     default:
//       return state;
//   }
// }
